var _path;

import * as React from "react";

function SvgMegaphone(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 9.333v21.334c0 .983-.794 1.777-1.778 1.777a1.776 1.776 0 01-1.778-1.777V9.333a1.777 1.777 0 113.556 0zM7.553 16.35l23.114-7.017v21.334l-7.284-2.212a5.33 5.33 0 01-5.16 3.99 5.303 5.303 0 01-5.334-5.334c0-.661.105-1.206.294-1.75l-5.63-1.711A1.778 1.778 0 014 23.555v-7.11a1.777 1.777 0 013.553-.095zm13.275 11.328l-5.09-1.545a2.667 2.667 0 002.483 3.645c1.229 0 2.346-.9 2.607-2.1z"
  })));
}

export default SvgMegaphone;